(() => {
  const selector = '[data-apple-pay-checkout]';

  function getForm(button) {
    return document.getElementById(button.dataset.applePayFormId);
  }

  function getErrorElement(button) {
    return button.closest('.apple-pay-checkout')?.querySelector('[data-apple-pay-error]');
  }

  function updateAvailability(button) {
    const form = getForm(button);
    const addToCart = form?.querySelector('[data-add-to-cart]');
    const variant = form?.querySelector('[name="id"]');

    const unavailable = !form || !variant?.value || Boolean(addToCart?.disabled);
    button.disabled = unavailable;
    button.closest('.apple-pay-checkout')?.classList.toggle('hidden', unavailable);
  }

  async function startCheckout(button) {
    const form = getForm(button);
    const errorElement = getErrorElement(button);

    if (!form || button.disabled || !form.reportValidity()) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (errorElement) errorElement.textContent = '';

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
        credentials: 'same-origin'
      });
      const result = await response.json().catch(() => ({}));

      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || window.theme?.strings?.unavailable || '');
      }

      window.location.assign(button.dataset.checkoutUrl || '/checkout');
    } catch (error) {
      if (errorElement) {
        errorElement.textContent = error instanceof Error ? error.message : window.theme?.strings?.unavailable || '';
      }
      updateAvailability(button);
    } finally {
      button.removeAttribute('aria-busy');
    }
  }

  function initialize(root = document) {
    root.querySelectorAll(selector).forEach((button) => {
      if (button.dataset.applePayInitialized) return;

      const form = getForm(button);
      if (!form) return;

      button.dataset.applePayInitialized = 'true';
      updateAvailability(button);
      button.addEventListener('click', () => startCheckout(button));

      const addToCart = form.querySelector('[data-add-to-cart]');
      if (addToCart) {
        new MutationObserver(() => updateAvailability(button)).observe(addToCart, {
          attributes: true,
          attributeFilter: ['disabled']
        });
      }
      form.addEventListener('change', () => requestAnimationFrame(() => updateAvailability(button)));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
